import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useStoreSelector } from '../..';
import { getActualAttributes } from '../../store/selectors/selectors';
import { PAGE_NAME } from '../../utils/constants';
import s from './Interface.module.scss';

// ─── Sub-components ───
import { NavigationHeader } from './components/NavigationHeader/NavigationHeader';
import { ConfigPanel } from './components/ConfigPanel/ConfigPanel';
import { ReviewPanel } from './components/ReviewPanel/ReviewPanel';

// ─── Hooks ───
import { useWindowResize } from './hooks/useWindowResize';
import { usePriceCalculator } from './hooks/usePriceCalculator';
import { useCartActions } from './hooks/useCartActions';

const ROUTE_LABELS: Record<string, string> = {
  [PAGE_NAME.Jeep2DoorJL]: 'Wrangler JL',
  [PAGE_NAME.Jeep4DoorJL]: 'Wrangler JL Unlimited',
  [PAGE_NAME.JeepGladiator]: 'Gladiator',
};

export const Interface = () => {
  const hasLoaded = true; // useThreekitInitStatus();
  const location = useLocation();
  const modelName = ROUTE_LABELS[location.pathname] || 'Jeep';

  const actualAttributes: any = useStoreSelector(getActualAttributes);
  const [configActiveMenu, setConfigActiveMenu] = useState(true);

  const actualParameters = useWindowResize();
  const actualPrice = usePriceCalculator(
    actualAttributes,
    hasLoaded,
    configActiveMenu
  );
  const { addToCart } = useCartActions();

  return (
    <div
      className={s.wrapper}
      style={
        actualParameters.windowWidth <= 992
          ? {
            height: `calc(var(--vh, 1vh) * 100 - 109px - ${actualParameters.playerHeight}px)`,
          }
          : {}
      }
    >
      <NavigationHeader modelName={modelName} />

      <ConfigPanel
        isActive={configActiveMenu}
        hasLoaded={hasLoaded}
        actualAttributes={actualAttributes}
        actualPrice={actualPrice}
        onReviewBuild={() => setConfigActiveMenu(false)}
      />

      <ReviewPanel
        isActive={!configActiveMenu}
        hasLoaded={hasLoaded}
        actualAttributes={actualAttributes}
        actualPrice={actualPrice}
        modelName={modelName}
        pathname={location.pathname}
        onBackToConfig={() => setConfigActiveMenu(true)}
        onCheckout={addToCart}
      />
    </div>
  );
};
